
import { apiSlice } from '../../app/api/apiSlice'
// Automatically created using reduxslicer by Simo Virokannas, 2023

export const designApi = apiSlice.injectEndpoints ({ 
  endpoints: (builder) => ({
    listDesigns: builder.query ({
      query: (params) => `v2/design/${params ? "?" + new URLSearchParams(Object.entries(params)).toString() : ""}`,
      keepUnusedDataFor: 1,
      providesTags: ["Design"]
    }),
    getDesign: builder.query ({
      query: (design_id) => `v2/design/${design_id}/`,
      keepUnusedDataFor: 1,
      providesTags: ["Design"]
    }),
    getDesignLayouts: builder.query ({
      query: (design_id) => `v2/designinlayout/?design=${design_id}`,
      keepUnusedDataFor: 1,
      providesTags: ["DesignInLayout"]
    }),
    updateDesign: builder.mutation ({
      query: ({design_id, data}) => ({
        url: `v2/design/${design_id}/`,
        method: 'PUT',
        body: data
      }),
      invalidatesTags: ["Design"]
    }),
    deleteDesign: builder.mutation ({
      query: (design_id) => ({
        url: `v2/design/${design_id}/`,
        method: 'DELETE'
      }),
      invalidatesTags: ["Design"]
    }),
    createDesign: builder.mutation ({
      query: (data) => ({
        url: `v2/design/`,
        method: 'POST',
        body: data
      }),
      invalidatesTags: ["Design"]
    }),
  })
})


export const {
  useListDesignsQuery,
  useLazyListDesignsQuery,
  useGetDesignQuery,
  useLazyGetDesignQuery,
  useGetDesignLayoutsQuery,
  useUpdateDesignMutation,
  useDeleteDesignMutation,
  useCreateDesignMutation
} = designApi
